<template>
    <div class="col-lg-9 col-md-9 col-xs-12 product-info">
        <h1 style="margin-top:0;margin-bottom:30px;font-size:30px;">
            Godstransport
        </h1>

        <div class="row" style="margin-bottom:30px;">
            <div class="col-lg-6">
                <img src="/static/images/stykgods_1.jpg" style="width:100%;border-radius:4px;"/>
            </div>
            <div class="col-lg-6">
                <img src="/static/images/stykgods_2.jpg" style="width:100%;border-radius:4px;"/>
            </div>
        </div>

        <h2 style="font-size:20px;">
            Godstransport mellem Fyn og Ærø
        </h2>
        <p>
            Fragt og Vognmandsfirma P. Pedersen & Søn Ærø kan hjælpe dig uanset hvilket gods du skal have transporteret, og vi klarer forsendelser af alt fra 0 kg småpakker til 38 tons.
            <br><br>
            Forsendelser afhentet hos en virksomhed, eller indleveret på vores lager i Odense Fyn inden kl. 09:00, leveres samme dag hos modtager på Ærø.
            <br><br>
        </p>
        <div class="box" style="overflow:hidden;">
            <div style="padding:10px 20px;background:#172b43;color:#fff;margin:-20px -20px 20px -20px;font-size:18px;font-weight:bold;padding-bottom:15px;margin-bottom:15px;">
                Vi tilbyder
            </div>
            <p>
                <b>Partigods</b>
            </p>
            <p>
                Skal du eller din virksomhed sende større partier som f. eks. paller, så er det partigods transport I skal vælge. Vi afhenter partiet hos afsender til den aftalte tid, og leverer hos modtager inden for den aftale tid.<br><br>
            </p>
            <p>
                <b>Stykgods</b>
            </p>
            <p>
                Stykgods er forsendelser på over 20 kg. Stykgods kan sendes enkeltvis, i små portioner eller i større partier og vi håndterer også langgods og farligt gods. Gods kan deles op i 2 typer efter vægt og rumfang. Letgods er primært gods mellem 100 kg og 1000 kg under 53 i rumfang resten benævnes sværgods.
            </p>
            <p>
                At fragte stykgods betyder enten at vi afhenter din pakke eller dine varer, og kører dem til et lager eller til en anden fragtbil, som derefter kører den ud til modtager. Eller betyder, at vi henter din pakke eller varer hos en virksomhed, lager eller anden fragtbil og fragter den til hjem til dig på Ærø. Vi gør os stor umage for at din pakke næsten ikke bliver flyttet undervejs – både for at skåne dit gods men også for at undgå skader. Stykgods kan også sendes som ekspresgods, hvis det ønskes.
            </p>
        </div>

        <div style="margin:30px 0;">
            <contact-cta />
        </div>

        <h2 style="font-size:20px;">
            Godstransport efter dine behov
        </h2>
        <p>
            Fragt og Vognmandsfirma P. Pedersen & Søn Ærø er eksperter i godstransport mellem Fyn og Ærø. Vi varetager hver dag transport for et hav af glade kunder, og vi vil også gerne hjælpe dig. En godstransport dækker over transport og flytning af varer og produkter i alskens kategorier, lige fra letgods, tungt gods, volumen gods, farligt gods, stykgods og pallegods fra A til B.
        </p>
        <p>
            Alle vores kunder er forskellige og har forskellige behov. Derfor sammensætter vi en unik fragt og logistik løsning, som passer til dit behov, uanset om du har brug for godstransport fra din egen virksomhed, eller en fra en tredjepart. Fragt og Vognmandsfirma P. Pedersen & Søn Ærø tilbyder dig godstransport, som passer til dine behov og altid til konkurrencedygtige priser.
        </p>

        <h3 style="margin-top:30px;margin-bottom:15px;font-size:16px;">
            Godstransport privat/erhverv
        </h3>
        <p>
            Hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø får du en hurtig og personlig service af erfarne chauffører, der kender deres opgaver. Vi lægger stor vægt på god relation til vores kunder, da vi mener at gode relationer er forbundet med en stor grad af troværdighed. Vi lover aldrig mere end hvad vi kan stå indenfor, og vi tilbyder vores ydelser til såvel store -, som små private virksomheder.
        </p>
        <p>
            Vi ønsker et partnerskab med vores kunder, hvor begge parter drager nytte af hinanden – så det bliver en win win situation. Fragt og Vognmandsfirma P. Pedersen & Søn Ærø sætter en dyd i yde den bedste service, hvor vi ved at alle kunder er forskellige. Vores medarbejdere står klar til at hjælpe dig, så de kender præcis dine /jeres behov. Vælger du Fragt og Vognmandsfirma P. Pedersen & Søn Ærø får du ikke alene en effektiv løsning der matcher dine ønsker. Du får chauffører som tager ejerskab ved at udføre et kvalitetsarbejde –for på den måde at bevare et tæt samarbejde langt ud i fremtiden.
        </p>

        <div style="margin-top:30px;">
            <contact-cta />
        </div>

        <h4 style="margin-top:30px;margin-bottom:15px;font-size:16px;">
            Godstransport med fragtbil
        </h4>
        <p>
            Fragt og Vognmandsfirma P. Pedersen & Søn Ærø skræddersyer transportløsninger til dig eller din virksomhed. Vælger du os til at transportere dit gods, får du en professionel samarbejdspartner med solid erfaring og stor kapacitet, da vores erfarne chauffører er meget effektive og hurtige til at læsse og  losse dine varer.
        </p>
        <p>
            Vi kan også tilbyde faste aftaler om dagligt at afhente og fragte dine varer, og hvis tid er vigtig, ringer vi i forvejen og fortæller dig at vi er på vej. Vi har mange typer fragtbiler, som tilgodeser dig som kunde hvis du har en opgave, som kræver noget specielt.
        </p>
        <p>
            Vi har fragtbiler som både er velegnede til de mindre gader og leverancer, samt større fragtbiler, der er velegnet til kørsel af stort gods. Og overalt hvor vi kører, sørger vi for at vise respekt i lokalsamfundet – og vi lægger stor vægt på at vi er mindst muligt til gene på vejene.
        </p>

        <!--<img style="width:calc(50% - 10px);float:left;margin-right:10px;" class="product-image" src="/static/images/stykgods_1.jpg" />
        <img style="width:calc(50% - 10px);float:left;margin-left:10px;" class="product-image" src="/static/images/stykgods_2.jpg" />-->
    </div>
</template>
<script>
    import Product from '../../../components/elements/product'
    export default {
        name: 'Stykgods',
        components: {
            'product': Product
        }
    }
</script>



// WEBPACK FOOTER //
// stykgods.vue?54fd896f